import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { css } from '@emotion/core';
import { functional } from 'Mui/styles/color';
import { system400 } from 'Mui/styles/color';

export default function ClickAwayContainer({
    isEditor,
    children,
    isFocused,
    sectionId,
    onClickAway,
    onClick = () => {},
    showHover = false,
    iconSlot
}) {
    return (
        <>
            {isEditor ? (
                <ClickAwayListener
                    onClickAway={() => {
                        if (isFocused) onClickAway();
                    }}
                >
                    <div
                        css={css(
                            borderStyle(isFocused, showHover),
                            iconSlot && containerWithIconStyle
                        )}
                        onFocus={() => {
                            onClick(sectionId);
                        }}
                    >
                        {isFocused && iconSlot}
                        {children}
                    </div>
                </ClickAwayListener>
            ) : (
                children
            )}
        </>
    );
}

const borderStyle = (isSelected, showHover) => css`
    border: ${isSelected ? `${functional.color} solid 2px` : 'none'};
    ${showHover &&
    !isSelected &&
    `
        &:hover {
            border: 2px dashed ${system400.color};
        }
    `}
`;

const containerWithIconStyle = css`
    position: relative;
`;
